<!--站点/运营页 故障设备表-->
<template>
    <div>
        <v-data-table
            disable-sort
            :headers="headers"
            :items="faultData"
            :items-per-page="5"
            class="elevation-1"
            hide-default-footer
            no-data-text="没有设备故障"
            loading-text="数据加载中..."
            :dark="theme.tableDark"
        ></v-data-table>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            headers: [
                { text: "时间", value: "time" },
                { text: "设备编号", value: "id" },
                { text: "所属站点", value: "site" },
                { text: "地址", value: "address" },
                { text: "责任人", value: "people" },
                { text: "联系方式", value: "phone" },
            ],
            desserts: [],
        };
    },
    computed: {
        ...mapState(["theme"]),
    },
    props: {
        faultData: Array,
    },
    methods: {},
};
</script>
